import { getRequest, patchRequest, postRequest } from "@/lib/api";

export type CareCategory = "VACCINATION" | "HEALTH" | "TRAINING";

export type CareItem = {
  id: string;
  orderId: string;
  category: CareCategory;
  title: string;
  note: string | null;
  dueDate: string | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
};

export type CreateCareItemInput = {
  category: CareCategory;
  title: string;
  note?: string;
  dueDate?: string;
};

export const getCareItems = (orderId: string) =>
  getRequest<CareItem[]>(`orders/${orderId}/care-items`);

export const createCareItem = (orderId: string, input: CreateCareItemInput) =>
  postRequest<CareItem, CreateCareItemInput>(
    `orders/${orderId}/care-items`,
    input,
  );

export const setCareItemCompleted = (
  orderId: string,
  itemId: string,
  completed: boolean,
) =>
  patchRequest<CareItem, { completed: boolean }>(
    `orders/${orderId}/care-items/${itemId}`,
    {
      completed,
    },
  );

export type CheckinMilestone = "DAY_3" | "WEEK_2" | "MONTH_3";
export type WellbeingStatus = "GOOD" | "WATCH" | "NEEDS_HELP";
export type SupportType = "NONE" | "RETURN" | "REHOMING";
export type SupportStatus =
  | "NOT_REQUESTED"
  | "REQUESTED"
  | "ACKNOWLEDGED"
  | "RESOLVED";
export type AftercareCheckin = {
  id: string;
  milestone: CheckinMilestone;
  wellbeing: WellbeingStatus;
  note: string;
  supportType: SupportType;
  supportDetails: string | null;
  supportStatus: SupportStatus;
  updatedAt: string;
};
export type AftercarePackage = {
  orderId: string;
  returnPolicy: string;
  milestones: {
    milestone: CheckinMilestone;
    dueAt: string;
    checkin: AftercareCheckin | null;
  }[];
};
export type SaveCheckinInput = {
  milestone: CheckinMilestone;
  wellbeing: WellbeingStatus;
  note: string;
  supportType: SupportType;
  supportDetails?: string;
};

export const getAftercare = (orderId: string) =>
  getRequest<AftercarePackage>(`orders/${orderId}/aftercare`);
export const saveAftercareCheckin = (
  orderId: string,
  input: SaveCheckinInput,
) =>
  postRequest<AftercareCheckin, SaveCheckinInput>(
    `orders/${orderId}/aftercare/checkins`,
    input,
  );
export const getBreederAftercare = (orderId: string) =>
  getRequest<AftercarePackage>(`breeders/me/orders/${orderId}/aftercare`);
export const updateAftercareSupport = (
  orderId: string,
  checkinId: string,
  status: "ACKNOWLEDGED" | "RESOLVED",
  note?: string,
) =>
  patchRequest<AftercareCheckin, { status: string; note?: string }>(
    `breeders/me/orders/${orderId}/aftercare/checkins/${checkinId}/support`,
    { status, note },
  );
